// ui/components/2-molecules/SurfaceSection/SurfaceSection.tsx
import React, { JSX } from 'react';
import classNames from 'classnames';
import styles from './SurfaceSection.module.scss';
import { Container } from 'ui/components/4-habitats';
import { mapSurfaceKey } from 'helpers/mapSurfaceKey';

export type Surface = 'primary';
export type ContainerWidth = '' | 'Small' | 'Standard' | 'Full width' | 'Slim' | 'Skinny' | 'StandardWeb' | 'SlimWeb';

export interface SurfaceSectionProps {
	children: React.ReactNode;
	className?: string;
	id?: string;
	surface?: Surface;
	surfaceKey?: string | null;
	withContainer?: boolean;
	containerWidth?: ContainerWidth;
	as?: keyof JSX.IntrinsicElements;
}

export const SurfaceSection: React.FC<SurfaceSectionProps> = ({
	children,
	className,
	id,
	surface,
	surfaceKey,
	withContainer = true,
	containerWidth = 'StandardWeb',
	as: Tag = 'section',
}) => {
	const rootClass = classNames(styles.SurfaceSection, className);
	const resolved: Surface = surface ?? mapSurfaceKey(surfaceKey);
	return (
		<Tag id={id} className={rootClass} data-surface={resolved} aria-live="off">
			{withContainer ? <Container width={containerWidth}>{children}</Container> : children}
		</Tag>
	);
};
